<script setup>
  import {ref} from "vue";

  import ComponentDialog from "@components/Dialogs/Dialog.vue";
  import ComponentIcon from "@components/Icons/Icon.vue";
  import {MedButton} from "@pharma4u/medicheck-components";

  defineOptions({
    name: "RecordComponentEmailHasSentDialog",
  });

  const refEmailHasSentDialog = ref(null);

  const sentEmailAddress = ref(null);

  const open = (email) => {
    sentEmailAddress.value = email;
    refEmailHasSentDialog.value.open();
  };

  const close = () => {
    if (refEmailHasSentDialog.value) refEmailHasSentDialog.value.close();
  };

  defineExpose({
    open,
    close,
  });
</script>

<template>
  <ComponentDialog ref="refEmailHasSentDialog" dialog-width="medium" :test-id="getTestId('email-has-sent')">
    <template #title>
      <div class="flex">
        <ComponentIcon class="text-2xl text-mcgreen">check</ComponentIcon>
        <span class="ml-3">E-Mail gesendet (verschlüsselt)</span>
      </div>
    </template>

    <template #content>
      Die E-Mail wurde erfolgreich an
      <strong>{{ sentEmailAddress }}</strong>
      versendet.
    </template>

    <template #actions>
      <MedButton variant="primary" :data-test="getTestId('email-has-sent-ok-button')" @click="close">OK</MedButton>
    </template>
  </ComponentDialog>
</template>
